import {type PropsWithChildren, useRef, useState} from 'react'
import {useSlots} from '@primer/react'
import {PathsProvider} from './contexts/PathsContext'
import type {Paths} from './types'
import {ButtonProvider} from './contexts/ButtonContext'
import {AnchorButton} from './components/anchor-button'
import {DialogWrapper} from './components/dialog-wrapper'
import {EnforcementProvider} from './contexts/EnforcementContext'

export type ImportBranchProtectionDialogProps = PropsWithChildren<{
  paths: Paths
  onOpen?: () => void
  onSuccess?: () => void
}>

ImportBranchProtectionDialog.AnchorButton = AnchorButton

const slotConfig = {
  anchorButton: ImportBranchProtectionDialog.AnchorButton,
}

export {ImportBranchProtectionDialog}

function ImportBranchProtectionDialog({children, paths, onOpen, onSuccess}: ImportBranchProtectionDialogProps) {
  const [isOpen, setIsOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const onDialogOpen = () => {
    onOpen?.()
    setIsOpen(true)
  }
  const onDialogClose = () => setIsOpen(false)
  const wrappedOnSuccess = () => {
    onSuccess?.()
    setIsOpen(false)
  }
  const [{anchorButton}] = useSlots(children, slotConfig)

  return (
    <PathsProvider paths={paths}>
      <ButtonProvider onClick={onDialogOpen} buttonRef={buttonRef}>
        <EnforcementProvider>
          {anchorButton || <AnchorButton>Import branch protection rules</AnchorButton>}
          {isOpen && <DialogWrapper onClose={onDialogClose} onSuccess={wrappedOnSuccess} />}
        </EnforcementProvider>
      </ButtonProvider>
    </PathsProvider>
  )
}
